"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_dom_1 = require("react-dom");
var browser_1 = require("@cian/fragment/browser");
var shared_1 = require("@cian/fragment/shared");
function initializeNewbuildingMVK(container) {
    react_dom_1.hydrate(React.createElement(browser_1.FragmentProvider, null,
        React.createElement(shared_1.Fragment, { type: "newbuildingMvkFragment" })), container);
}
exports.initializeNewbuildingMVK = initializeNewbuildingMVK;



//////////////////
// WEBPACK FOOTER
// ./src/browser/initializers/newbuilding_mvk.tsx
// module id = 304
// module chunks = 2